import { render, staticRenderFns } from "./panel_actions_portal.vue.js?vue&type=template&id=20022ca9&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./panel_actions_portal.vue?vue&type=template&id=20022ca9&vue3"
import script from "./panel_actions_portal.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./panel_actions_portal.vue?vue&type=script&lang=js&vue3"
export * from "./panel_actions_portal.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./panel_actions_portal.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports